import React, {useMemo} from 'react';
import {classes, style} from './doppe-layout-page-content.st.css';
import {BymoTemplateMetadataInferBymoPageProps} from '../../../../doppe-sdk';
import {DoppLayoutContentTitle} from '../dopp-layout-content-title/dopp-layout-content-title';
import {DoppeLayoutSearchSection} from '../doppe-layout-search-action/doppe-layout-search-section';
import {
    BymoTemplateSpeedDialActionsListAppearance,
    BymoTemplateSpeedDialSearchAppearance,
    BymoTemplateSpeedDialTemplateMetadata
} from '../../../bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial.metadata';
import {DoppLayoutSeparator, DoppLayoutSeparatorSkin} from '../dopp-layout-separator/dopp-layout-separator';
import {DoppLayoutContentHeader} from '../dopp-layout-content-header/dopp-layout-content-header';
import {DoppeLayoutActionsList} from '../doppe-layout-actions-list/doppe-layout-actions-list';
import {doppeHideableValueGetVisibleValue} from '../../../../client-server-common';
import {iterableAny, OmitStrict} from '@wix/devzai-utils-common';
import {doppeActionIsVisibleInPage} from "../../../../client-server-common/types/doppe-dto-action";

export const DoppeLayoutPageContent = React.memo(function DoppeLayoutPageContent(props: DoppeLayoutPageContent.Props) {
    const {
        className,
        children,

        pageProps,
        searchHeaderClassName,
        actionsHeaderClassName,
        showSeparatorAboveSearchSection = false,

        ...htmlAttributes
    } = props;

    const {
        actionsHeading,
        actions,
        actionButtonTemplate,
        showActionsInSearch,
        searchPlaceholder,
        callToActionText,
        pageTitle,
        searchAppearance,
        actionsListAppearance,
    } = pageProps;

    const searchSectionIsVisible = searchAppearance !== BymoTemplateSpeedDialSearchAppearance.Hidden;

    const hasActions = useMemo(()=>{
        return iterableAny(actions, doppeActionIsVisibleInPage);
    }, [actions]);

    const actionsHeadingVisibleValue = doppeHideableValueGetVisibleValue(actionsHeading, '');

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
        >
            <DoppLayoutContentTitle
                text={pageTitle}
            />
            {searchSectionIsVisible && showSeparatorAboveSearchSection ? (
                <DoppLayoutSeparator
                    className={style(classes.separatorBeforeSearchSection, {})}
                    skin={DoppLayoutSeparatorSkin.Actions}
                />
            ) : null}
            <DoppeLayoutSearchSection
                actionButtonTemplate={actionButtonTemplate}
                searchPlaceholder={searchPlaceholder}
                showActionsInSearch={showActionsInSearch}
                searchAppearance={searchAppearance}
                callToActionText={callToActionText}
                searchHeaderClassName={searchHeaderClassName}
            />
            {actionsListAppearance !== BymoTemplateSpeedDialActionsListAppearance.Hidden ? (
                <>
                    {
                        searchSectionIsVisible && (hasActions || actionsHeadingVisibleValue) ?
                            <DoppLayoutSeparator
                                className={style(classes.separator, {})}
                                skin={DoppLayoutSeparatorSkin.Actions}
                            />
                            :
                            null
                    }
                    <DoppLayoutContentHeader
                        text={actionsHeading}
                        className={style(classes.actionsHeader, {}, actionsHeaderClassName)}
                    />
                    <DoppeLayoutActionsList
                        actions={actions}
                        className={style(classes.actionsList, {})}
                        actionButtonTemplate={actionButtonTemplate}
                    />
                </>
            ) : null}
        </div>
    )
});

export namespace DoppeLayoutPageContent {

    export interface Props extends OmitStrict<React.HTMLAttributes<any>, 'children'> {
        pageProps: BymoTemplateMetadataInferBymoPageProps<typeof BymoTemplateSpeedDialTemplateMetadata>;
        showSeparatorAboveSearchSection?: boolean;
        searchHeaderClassName?: string;
        actionsHeaderClassName?: string;
        children?: undefined;
    }
}